class ProductObjectives {
  static rateObjectiveName = "units_per_hour";
  static giveawayObjectiveName = "giveaway";

  rateObjectiveName = ProductObjectives.rateObjectiveName;
  giveawayObjectiveName = ProductObjectives.giveawayObjectiveName;
}

export default new ProductObjectives();
